import { z } from 'zod';

/// ////////////////////////////////////////////
/// Model
/// ////////////////////////////////////////////

export const PaymentGroupUploaderTemplate = z.object({
  csv: z.string().array().array(),
});
